import React from 'react';
import { connect } from 'react-redux';
import { Collapse } from '@mui/material';
import { createActions } from '../../../../store';
import CondensedListItem from '../../../../../../list-items/CondensedListItem';
import SwitchListItem from '../../../../../../list-items/SwitchListItem';
import BackdropDriftIntensitySlider from './BackdropDriftIntensitySlider';
import BackdropDriftAmplitudeXListItem from './BackdropDriftAmplitudeXListItem';
import BackdropDriftAmplitudeYListItem from './BackdropDriftAmplitudeYListItem';
import BackdropDriftRotationListItem from './BackdropDriftRotationListItem';
import BackdropDriftSpeedListItem from './BackdropDriftSpeedListItem';
import BackdropDriftScaleListItem from './BackdropDriftScaleListItem';
import BackdropDriftAccelerationListItem from './BackdropDriftAccelerationListItem';
import { interpolateBackgroundDrift, estimateIntensity, BACKGROUND_ANCHORS } from '../../../../Preview/effects/drift/driftUtilities';

// Drift sub-controls (intensity + optional custom parameters). Extracted from the old
// standalone Drift toggle so the Movement control can render them when Drift is selected.
const BackdropDriftControls = (props) => {
    const { drift, customizeOpen, updateBackgroundSettings } = props;

    const onCustomizeChange = (value) => {
        if (value) {
            const params = interpolateBackgroundDrift(drift?.intensity ?? 0);
            updateBackgroundSettings({ drift: { ...params, customMode: true } });
        } else {
            const intensity = estimateIntensity(drift, BACKGROUND_ANCHORS) ?? drift?.intensity ?? 0;
            updateBackgroundSettings({ drift: { intensity, customMode: false } });
        }
    };

    return (
        <>
            <BackdropDriftIntensitySlider />
            <SwitchListItem
                text='Custom'
                checked={customizeOpen}
                onChange={(e) => onCustomizeChange(e.target.checked)}
            />

            <Collapse in={customizeOpen} timeout="auto" unmountOnExit>
                <CondensedListItem
                    elements={[
                        { width: 6, component: <BackdropDriftAmplitudeXListItem /> },
                        { width: 6, component: <BackdropDriftAmplitudeYListItem /> }
                    ]}
                />
                <CondensedListItem
                    elements={[
                        { width: 6, component: <BackdropDriftRotationListItem /> },
                        { width: 6, component: <BackdropDriftScaleListItem /> }
                    ]}
                />
                <CondensedListItem
                    elements={[
                        { width: 6, component: <BackdropDriftSpeedListItem /> },
                        { width: 6, component: <BackdropDriftAccelerationListItem /> }
                    ]}
                />
            </Collapse>
        </>
    );
};

const mapStateToProps = (state) => {
    const drift = state.createPreview.present.videoSettings.background.drift;
    return {
        drift,
        customizeOpen: Boolean(drift?.customMode)
    };
};

const mapDispatchToProps = (dispatch) => ({
    updateBackgroundSettings: (properties) => dispatch(createActions.updateBackgroundSettings(properties))
});

export default connect(mapStateToProps, mapDispatchToProps)(BackdropDriftControls);
